import { axios } from '@/services/axios';

const assignTCAPUser = async ({ tcapUserId, platformUserId, scope }) => {
    const res = await axios.post(
        `/TcapUser/${tcapUserId}/PlatformUser/${platformUserId}/Assign`,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
    return res.data;
};

export default assignTCAPUser;
